import { createFileRoute } from '@tanstack/react-router';

import { ContentEditor } from '../../../@components/content-editor/ContentEditor';
import { medicationCreateEditorSettings } from '../../../@components/content-editor/medicationCreateEditorSettings';

export const Route = createFileRoute(
  '/_layout/(private)/my-medications/$id/new/',
)({
  component: MyMedicationsNewDetails,
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(
      medicationCreateEditorSettings.detailsQueryOptions(params.id),
    );
  },
});

function MyMedicationsNewDetails() {
  const { id } = Route.useParams();

  return <ContentEditor id={id} settings={medicationCreateEditorSettings} />;
}
